import React from "react";

import ChatContainer from "../../../components/chat";


const DeviationChat = ({record, ...props}) => (
	<ChatContainer
		record={record}
		resourcePath={`deviations/${record.id}/messages`}
		{...props}
	/>
);

export default DeviationChat;
